/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snackbar_SuccessInputs */

const en_snackbar_success = /** @type {(inputs: Snackbar_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Success`)
};

const de_snackbar_success = /** @type {(inputs: Snackbar_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfolg`)
};

/**
* | output |
* | --- |
* | "Success" |
*
* @param {Snackbar_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const snackbar_success = /** @type {((inputs?: Snackbar_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snackbar_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_snackbar_success(inputs)
	return de_snackbar_success(inputs)
});